module.exports = __webpack_public_path__ + "static/UIColors@2x-619fb05e989c27d520d3fca0e5b13fbe.jpg";